import React from 'react';

const Breadcrumb = props => (
  <ol className={`breadcrumb ${props.stillSearch ? 'hidden' : ''}`}>
    <li className='breadcrumb-item'>
      <p className='breadcrumb-item-title breadcrumb-item-font'>Volver a</p>
      <a className=' breadcrumb-item-link breadcrumb-item-content' onClick={props.goToClients}>
        { props.searchByProforma ? 'Proforma' : 'Clientes'}
      </a>
    </li>
    <li className='breadcrumb-item'>
      <div className='breadcrumb-item-content'>
        <p className='breadcrumb-item-head'>Proforma(s) de:</p>
        <p className='breadcrumb-item-title'>{props.clientName}</p>
      </div>
    </li>
  </ol>
);

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/Breadcrumb.js